import React from 'react'

import { TruncateWithTooltip } from '@sketch/components'

import NotificationListItemAvatar from './NotificationListItemAvatar'

import {
  NotificationDescription,
  NotificationShareName,
  NotificationBody,
} from '../NotificationListItem.styles'

import { WorkspaceInviteAcceptedNotificationFragment } from '@sketch/gql-types'

interface WorkspaceInviteAcceptedNotificationListItemProps {
  notification: WorkspaceInviteAcceptedNotificationFragment
}

const WorkspaceInviteAcceptedNotificationListItem: React.FCC<
  WorkspaceInviteAcceptedNotificationListItemProps
> = ({ notification }) => {
  const workspaceName = notification.workspace?.name ?? notification.title
  const inviteeName = notification.user?.name ?? ''
  const inviteeAvatar = notification.user?.avatar?.small ?? ''

  return (
    <>
      <NotificationShareName data-testid="notification-share-name">
        <TruncateWithTooltip>{workspaceName}</TruncateWithTooltip>
      </NotificationShareName>
      <NotificationBody data-testid="notification-body">
        <NotificationListItemAvatar avatar={inviteeAvatar} name={inviteeName} />
        <NotificationDescription data-testid="notification-description">
          {notification.subtitle}
        </NotificationDescription>
      </NotificationBody>
    </>
  )
}

export default WorkspaceInviteAcceptedNotificationListItem
